import { useRef, useState } from 'react';
import Recaptcha from 'react-google-recaptcha';

import { ENV_RECAPTCHA_SITE_KEY } from '@lib/core/service/consts';
import { useTechnical } from '@lib/core/service/hooks/useTechnical';
import { useDevtoolsUser } from '@lib/core/users/hooks';
import { actionDevtoolsLogin, actionResetDevtoolsUser } from '@lib/core/users/slices/devtoolsUser';
import { Button } from '@lib/tools/devtools/components/inputs/Button';
import { useTypedDispatch } from '@lib/tools/views/hooks';
import { ReCaptchaContainer } from '@lib/tools/views/web/containers/reCaptchaContainer';

export const LoginForm = () => {
  const dispatch = useTypedDispatch();
  const recaptchaRef = useRef<Recaptcha>(null);

  const [, setIsBtnDisabled] = useState(ENV_RECAPTCHA_SITE_KEY && !!ENV_RECAPTCHA_SITE_KEY);
  const { isCaptchaDisabled } = useTechnical();
  const { error } = useDevtoolsUser();
  const [email, setEmail] = useState<string>();
  const [password, setPassword] = useState<string>();

  const handleLogin = async (siteKey?: string) => {
    // ! Captcha is disabled on the PMI backend environment in v0.8
    await dispatch(actionResetDevtoolsUser());
    if (!error) {
      await dispatch(
        actionDevtoolsLogin({
          captchaValue: siteKey,
          email,
          isCaptchaDisabled,
          password,
        }),
      );
    } else {
      // setSnackbarMessage(JSON.stringify(error));
    }
  };

  const activateRecaptcha = () => {
    if (recaptchaRef.current) {
      recaptchaRef.current.execute();
    } else {
      handleLogin();
    }
  };

  return (
    <>
      <ReCaptchaContainer
        handleValue={handleLogin}
        isShowRecaptcha={!!ENV_RECAPTCHA_SITE_KEY && !isCaptchaDisabled}
        recaptchaRef={recaptchaRef}
        setIsBtnDisabled={setIsBtnDisabled}
      />
      <div className="login-panel">
        <input
          className="login-panel-input"
          placeholder="Email"
          type="email"
          onChange={e => setEmail(e.target.value)}
        />
        <input
          className="login-panel-input"
          placeholder="Password"
          type="password"
          onChange={e => setPassword(e.target.value)}
        />
        {error?.message && <span>{error?.message}</span>}
        <Button onClick={activateRecaptcha}>Login</Button>
      </div>
    </>
  );
};
